module.exports = __webpack_public_path__ + "img/expansion.bb1258ba.png";